import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const BackButton = () => {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate(-1)}
            className="mb-3 flex items-center gap-2 px-4 py-2 text-sm font-medium text-purple-700 border border-purple-700 rounded-lg hover:bg-purple-50 transition-all duration-300"
        >
            <FiArrowLeft size={18} />
            Back
        </button>
    );
};

export default BackButton;
